import React, { useState, useEffect } from 'react'

import { ThemeProvider } from '@intelie/ui'
import liveTheme, { mergeIntelieUiTheme } from 'live/services/theme'
import LiveHeader from 'live/components/header/ui/main/main'

import styled from 'styled-components'
import ImporterApp from './importer/ImporterApp'
import { ImporterHeader } from './importer/global-components/ImporterHeader'
import { StaticDataImporterProvider } from './importer/context/StaticDataImporterContext'
import authorization from 'live/services/authorization'
import { NoViewPermission } from './importer-optimized/temporary-data-table/components/NoViewPermission'

const hasPermissionToView =
    authorization.superAdmin ||
    authorization.admin ||
    authorization.Permission.ADMIN ||
    authorization.Permission.OGPERFORMANCE_MANAGE_KPI ||
    authorization.Permission.OGPERFORMANCE_ADMINISTRATE_KPI ||
    authorization.Permission.OGPERFORMANCE_VIEW_KPI

const App = (): JSX.Element => {
    const [top, setTop] = useState(0)

    const mergeWithLiveTheme = theme => {
        const merged = mergeIntelieUiTheme(theme, liveTheme)

        return merged
    }

    useEffect(() => {
        setTop(document.querySelector('nav').getBoundingClientRect().height)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [document.querySelector('nav')])

    return (
        <ThemeProvider cssVarsSelector=":root" themeMerger={mergeWithLiveTheme}>
            <AppStyles className="app-container">
                <LiveHeader />
                <div className={'inner-app'} style={{ overflowY: 'hidden', top }}>
                    <ImporterHeader />
                    {hasPermissionToView ? (
                        <StaticDataImporterProvider>
                            <ImporterApp />
                        </StaticDataImporterProvider>
                    ) : (
                        <NoViewPermission />
                    )}
                </div>
            </AppStyles>
        </ThemeProvider>
    )
}

const AppStyles = styled.div`
    position: relative;
    height: 100%;

    .inner-app {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
`

export default App
